export enum EPayslipType {
  PAYROLL = "PAYROLL",
  PRODUCTIVITY = "PRODUCTIVITY",
  PRODUCTIVITY_SALARY_SUMMARY = "PRODUCTIVITY_SALARY_SUMMARY",
}

export enum PayslipTemplateType {
  PDFMAKE = "pdfmake",
  HTML = "html",
}

export const PayslipTemplateTypeOptions = Object.values(
  PayslipTemplateType
).map((value) => ({ label: value.toUpperCase(), value }));

export const PayslipTypeOptions = Object.values(EPayslipType).map((value) => ({
  label: value,
  value,
}));

export interface PayslipTemplate {
  id: string;
  orgId: number;
  code: string;
  templateName: string;
  template: unknown;
  field: unknown;
  type: EPayslipType;
  generateField: unknown;
  templateType: PayslipTemplateType;
  html: string;
  status: number;
  createdAt: string;
  updatedAt: string;
}

export interface PayslipTemplateListRequest {
  keyword?: string;
  type?: string;
  templateType?: string;
  status?: number;
  page?: number;
  limit?: number;
}

export interface PayslipTemplateListResponse extends RestAPIMetaResponse {
  items: Array<PayslipTemplate>;
}

export interface PayslipTemplateCreateRequest {
  templateName: string;
  code?: string;
  type?: string;
  template?: unknown;
  field?: unknown;
  generateField?: unknown;
  templateType?: string;
  html?: string;
}

export interface PayslipTemplateUpdateRequest
  extends Partial<PayslipTemplateCreateRequest> {
  id: string;
  status?: number;
}
